import { render, staticRenderFns } from "./calendar.view.vue?vue&type=template&id=6565d890&scoped=true"
import script from "./calendar.view.vue?vue&type=script&lang=js"
export * from "./calendar.view.vue?vue&type=script&lang=js"
import style0 from "./calendar.view.vue?vue&type=style&index=0&id=6565d890&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6565d890",
  null
  
)

export default component.exports